import React from 'react'
import './App.css'
import {Icon} from "./components/FormComps";

export default function Page404(props) {

  return (
      <main>
        <div class="jumbotron m-3">
          <center>
            <h1 style={{fontSize: "4.5rem", color: "var(--color-warning)"}}><Icon name="not_found"/></h1>
            <h1 style={{fontSize: "2.5rem", color: "var(--title-color)"}}>Not Found</h1>
            <p className="lead" style={{color: "var(--label-color)"}}>
              <p>The page at <code>{props.location.pathname}</code> you're looking for does not exist or an error has occurred.</p>
              <div className="d-flex flex-row justify-content-center gap-2 mt-4">
                <a className="btn btn-primary" style={{fontSize: "1.171875rem;"}} href="javascript:window.history.back()">
                  Go Back
                </a>
                <a href="/" className="btn btn-secondary" style={{fontSize: "1.171875rem;"}}>
                  Home
                </a>
              </div>
            </p>
          </center>
        </div>
      </main>
    )
}
